var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearRespirator50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,21.202V20c0-6.617-5.383-12-12-12s-12,5.383-12,12v1.202c-1.201,0.513-2,1.954-2,3.798 c0,2.978,1.948,5.111,3.181,5.927c0.695,1.871,1.648,3.362,2.745,4.53c0.428-0.44,0.986-0.838,1.666-1.176 c-1.03-1.024-1.976-2.419-2.646-4.358l-0.134-0.385l-0.364-0.183C14.045,29.154,12,27.588,12,25c0-0.983,0.374-2,1-2h1v-3 c0-5.514,4.486-10,10-10s10,4.486,10,10v3h1c0.626,0,1,1.017,1,2c0,2.588-2.045,4.154-2.447,4.355l-0.364,0.183l-0.134,0.385 c-0.671,1.939-1.617,3.334-2.646,4.358c0.68,0.338,1.238,0.736,1.666,1.176c1.097-1.168,2.05-2.659,2.745-4.53 C36.052,30.111,38,27.978,38,25C38,23.156,37.201,21.715,36,21.202z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,35c-4.273,0-7,1.48-7,2.5c0,1.933,3.134,3.5,7,3.5s7-1.567,7-3.5C31,36.48,28.273,35,24,35z M20,38c-0.552,0-1-0.224-1-0.5s0.448-0.5,1-0.5s1,0.224,1,0.5S20.552,38,20,38z M22,40c-0.552,0-1-0.224-1-0.5s0.448-0.5,1-0.5 s1,0.224,1,0.5S22.552,40,22,40z M24,38c-0.552,0-1-0.224-1-0.5s0.448-0.5,1-0.5s1,0.224,1,0.5S24.552,38,24,38z M26,40 c-0.552,0-1-0.224-1-0.5s0.448-0.5,1-0.5s1,0.224,1,0.5S26.552,40,26,40z M28,38c-0.552,0-1-0.224-1-0.5s0.448-0.5,1-0.5 s1,0.224,1,0.5S28.552,38,28,38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35,17h-1c0,0-2-2-10-2s-10,2-10,2h-1v6h1v7.25c0.669,1.934,1.621,3.421,2.707,4.555 C18.314,33.697,20.927,33,24,33s5.686,0.697,7.293,1.805c1.086-1.135,2.038-2.622,2.707-4.555V23h1V17z M19.5,27 c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5S20.881,27,19.5,27z M28.5,27c-1.381,0-2.5-1.119-2.5-2.5 s1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5S29.881,27,28.5,27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearRespirator50);
export default __webpack_public_path__ + "static/media/icons8-wear-respirator-50.8bb914e80fac591095ff9a2f4174c61f.svg";
export { ForwardRef as ReactComponent };